module.exports = __webpack_public_path__ + "static/nesting-tree-02f60a4071c83a06d4e1fee7ebe4cf9f.png";